import React from 'react';
import { TrackedObject } from '../types';
import { formatDistance } from 'date-fns';

interface ObjectsListProps {
  objects: TrackedObject[];
  onSelectObject: (id: string) => void;
  selectedObjectId?: string;
  onRefresh?: (id: string) => void;
  refreshingIds?: Set<string>;
}

const ObjectsList: React.FC<ObjectsListProps> = ({ 
  objects, 
  onSelectObject,
  selectedObjectId,
  onRefresh,
  refreshingIds = new Set(),
}) => {
  // Filter to show only objects updated in the last 5 minutes
  const activeObjects = objects.filter(obj => {
    const fiveMinutesAgo = Date.now() - 5 * 60 * 1000;
    return obj.lastUpdate > fiveMinutesAgo;
  });

  return (
    <div className="objects-list">
      <div className="objects-list-header">
        <h2>Tracked Objects ({activeObjects.length})</h2>
      </div>
      {activeObjects.length === 0 ? (
        <p className="no-objects">No active objects found</p>
      ) : (
        <ul className="objects-list-items">
          {activeObjects.map(obj => (
            <li 
              key={obj.id}
              className={`objects-list-item ${selectedObjectId === obj.id ? 'selected' : ''}`}
              onClick={() => onSelectObject(obj.id)}
            >
              <div className="object-info">
                <div className="object-name">{obj.name}</div>
                <div className="object-details">
                  <span className="object-status">
                    Updated {formatDistance(obj.lastUpdate, new Date(), { addSuffix: true })}
                  </span>
                  <span className="object-coordinates">
                    {obj.latitude.toFixed(4)}, {obj.longitude.toFixed(4)}
                  </span>
                </div>
              </div>
              {onRefresh && (
                <button
                  className="refresh-btn"
                  disabled={refreshingIds.has(obj.id)}
                  onClick={(e) => {
                    e.stopPropagation();
                    onRefresh(obj.id);
                  }}
                  title="Refresh location"
                >
                  {refreshingIds.has(obj.id) ? '⟳' : '↻'}
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ObjectsList;
